import {
    primaryColor,
    secondaryColor,
    whiteColor,
    blackColor,
  } from "@themes/defaultThemeProps";
    
    const commonStyle = {
      select: {
        width: '100%',
        '&:before': {
            borderColor: primaryColor[0],
        },
        '&:after': {
            borderColor: primaryColor[0],
        },
        '&:not(.Mui-disabled):hover::before': {
            borderColor: primaryColor[0],
        },
      },
      inputLabel: {
        "&.Mui-focused": {
          color: primaryColor[0],
        }
      },
      text: {
        color: blackColor,
      },
      outlineSelect: {
        "& > fieldset": { 
          width: '100%',
          "&": {
            borderColor: `${primaryColor[0]} !important`,
          }
        },
      },
      textDanger: {
      color: "#f44336"
    },
    };
    
    export default commonStyle;
    